import React from 'react';
import { ActionCableConsumer, ActionCableProvider } from '@thrash-industries/react-actioncable-provider';
import { getCableEndpoint } from '@squirrellearningltd/go-shared-utils';

export const ActionCableWrapper = ({ children }) => {

    //const cable = ActionCable.createConsumer(cableEndpoint());

    return (
        <ActionCableProvider url={getCableEndpoint()}>
            {children}
        </ActionCableProvider>
    );
};


export const NotifCableConsumer = ({ id, onForcedLogout, onLogout }) => {
    return (
        <ActionCableConsumer
            channel={{
                channel: 'NotificationsChannel',
                id
            }}
            onReceived={(message) => {
                if (message.logged_out) {
                    onLogout();
                }

                if (message.forced_logged_out && onForcedLogout) {
                    onForcedLogout();
                }
            }}
        ></ActionCableConsumer>
    )
}